// extracted by mini-css-extract-plugin
export default {"container":"container-YoSvFl2EzJWVfdMhqCbN","content":"content-bWybRRfpdKeBIFI6WovJ","chevron":"chevron-WOROqFYKz2hWRzlMppj9","pictoChevron":"pictoChevron-pPCusr6ZW1WKi6vlar0J"};